import React from 'react';

import BaseComponent from '../../../baseClasses/BaseComponent';
import emailIcon from '../../../assets/images/email-icon-gray.svg';
import emailActiveIcon from '../../../assets/images/email-icon.svg';
import './EmailButton.scss';
import EmailUserSelectionPopup from '../EmailUserSelectionPopup';

class EmailButton extends BaseComponent {

  constructor(props) {
    super(props);

    this.state= { 
      displayPopUp: null,
      change: false,
    };
  }

  handleDisplayPopup() {
    this.setState({ displayPopUp: true });
  }

  handleClosePopup() {
    if(this.props.handleUnselect){
      this.props.handleUnselect();
    }
    this.setState({ displayPopUp: false });
  }

  render() {
    const {  attachments, enabled } = this.props;
   
    let attachmentIds = '';
    if(attachments){
      for(let i = 0; i < attachments.length; i++){
        if(i + 1 != attachments.length){
          attachmentIds += attachments[i] + ',';
        }
        else {
          attachmentIds += attachments[i];
        }
      }
    }

    let popUp = this.state.displayPopUp && <EmailUserSelectionPopup companyId={this.props.companyId} marketId={this.props.marketId} attachmentIds={this.props.attachments}
    handleClosePopup={this.handleClosePopup}/>;
    
    return (

      <div className={'email-button' + (enabled ? ' enabled': '')}>
        {popUp}
        <a className="email-button--send" onClick={enabled ? ()=> this.handleDisplayPopup() : null}>
          <img className='email-button--icon' src={enabled ? emailActiveIcon : emailIcon} alt="email"/>
          <p className={enabled ? 'email-button--active-text' : 'email-button--text'}>EMAIL</p>
        </a>
      </div>
    );
  }
}

export default (EmailButton);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/EmailButton/index.js